import { createAction } from '@reduxjs/toolkit';

export const captureEligibilityTime = createAction(
  'loanValues/captureEligibilityTime',
  function prepare(time) {
    return {
      payload: time
    };
  }
);

export const setLoanTerm = createAction('loanValues/setLoanTerm', function prepare(term) {
  return {
    payload: term
  };
});

export const setRepaymentDay = createAction('loanValues/setRepaymentDay', function prepare(day) {
  return {
    payload: day
  };
});

export const setLoanAmount = createAction('loanValues/setLoanAmount', function prepare(amount) {
  return {
    payload: amount
  };
});

export const showDebtModal = createAction('loanValues/showDebtModal');

export const showBeforeScreenModal = createAction('loanValues/showBeforeScreenModal');

export const hideDebtModal = createAction('loanValues/hideDebtModal');

export const hideBeforeScreenModal = createAction('loanValues/hideBeforeScreenModal');

export const showCard = createAction('loanValues/showCard', function prepare(showCard) {
  return {
    payload: showCard
  };
});

export const showFinancialValidation = createAction(
  'loanValues/showFinancialValidation',
  function prepare(showFinancialValidation) {
    return {
      payload: showFinancialValidation
    };
  }
);

export const showDebtAmount = createAction(
  'loanValues/showDebtAmount',
  function prepare(hasDebtAmount) {
    return {
      payload: hasDebtAmount
    };
  }
);

export const selectDebtConsolidate = createAction(
  'loanValues/selectDebtConsolidate',
  function prepare(debtConsolidateSelected) {
    return {
      payload: debtConsolidateSelected
    };
  }
);
export const selectBeforeScreen = createAction(
  'loanValues/selectBeforeScreen',
  function prepare(beforeScreenSelected) {
    return {
      payload: beforeScreenSelected
    };
  }
);
export const financialDetailsChanged = createAction(
  'loanValues/financialDetailsChanged',
  function prepare(isChanged) {
    return {
      payload: isChanged
    };
  }
);

export const updateDebtAmountConsolidate = createAction(
  'loanValues/updateDebtAmountConsolidate',
  function prepare(debtAmountConsolidate) {
    return {
      payload: debtAmountConsolidate
    };
  }
);
